import React from 'react';
import * as PropTypes from 'prop-types';

import { Spacer } from './elements';

function Spa08(props) {
  return <Spacer className={props.className} />;
}

Spa08.propTypes = {
  className: PropTypes.string,
};

export default Spa08;
